import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import Loader from 'Common/components/Loader';
import getTasksProgress from 'Company/api/getTasksProgress';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';
import RetryLoading from 'Common/components/RetryLoading';
import PieChart from 'Common/components/PieChart';
import colors from 'Common/constants/colors';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    margin-bottom: 1px;
`;

const Title = styled.h2`
    margin: 0 0 40px;
    color: ${colors.DIRTY_WHITE};
    font-size: 23px;
`;

const TasksProgress = ({ title }) => {
    const {
        data: stats,
        loadData: loadStats,
        isLoading,
        hasError,
    } = useAxiosRequest(getTasksProgress, {
        all: 0,
        pending: 0,
        completed: 0,
    });

    const percentage =
        stats.all > 0 ? Math.floor((stats.completed / stats.all) * 100) : 0;

    return (
        <Wrapper>
            {!!title && <Title>{title}</Title>}
            {isLoading ? (
                <Loader />
            ) : hasError ? (
                <RetryLoading onRetry={loadStats} />
            ) : (
                <PieChart
                    data={[
                        {
                            id: 'completed',
                            label: 'Abgeschlossen',
                            value: stats.completed,
                            backgroundColor: colors.PRIMARY,
                        },
                        {
                            id: 'pending',
                            label: 'Ausstehend',
                            value: stats.pending,
                            backgroundColor: colors.SEARCH_FIELD_BORDER,
                        },
                        {
                            id: 'others',
                            label: 'Andere',
                            value: stats.all - stats.completed - stats.pending,
                            backgroundColor: colors.SEARCH_FIELD_BORDER,
                        },
                    ]}
                    percentage={percentage}
                    text="Aufgaben erledigt"
                    size={170}
                />
            )}
        </Wrapper>
    );
};

TasksProgress.defaultProps = {
    title: null,
};

TasksProgress.propTypes = {
    title: PropTypes.string,
};

export default TasksProgress;
